import BalanceService from '../Services/BalanceService';
import { frc } from 'front-end-common';
import { createAction, createReducer } from '@reduxjs/toolkit';

const { getDefaultHandler, getDefaultState } = frc.utils.reducerTools;



export const balanceFetchListReset = createAction('balance/fetch-list_RESET')

export const balanceFetchList = createAction('balance/fetch-list', (dates) => ({
  payload: BalanceService.fetchList(dates),
}))

export const balanceFetchListInvoices = createAction('balance/fetch-list-invoices', (dates) => ({
  payload: BalanceService.fetchListInvoices(dates),
}))

export const balanceFetchListReplenishments = createAction('balance/fetch-list-replenishments', (dates) => ({
  payload: BalanceService.fetchListReplenishments(dates),
}))

export const balanceTopUp = createAction('balance/top-up', (data) => ({
  payload: BalanceService.topUpBalance(data)
}))

export const balanceFetchListOrders = createAction('balance/fetch-list-orders', (dates) => ({
  payload: BalanceService.fetchListOrders(dates),
}))

export const balanceFetchListNonMgr = createAction('balance/fetch-list_account', (dates) => ({
  payload: BalanceService.fetchListNonMgr(dates),
}))

export const balanceGeneratePDF = createAction('balance/generate-pdf', () => ({
  payload: BalanceService.generatePDF(),
}))

export const balanceGenerateCSV = createAction('balance/generate-csv', () => ({
  payload: BalanceService.generateCSV(),
}))

export const getBalanceById = createAction('balance/get', (id) => ({
  payload: BalanceService.getBalanceByUserId(id),
}))

export const customersChangeBalance = createAction('balance/change', (params) => ({
  payload: BalanceService.changeBalance(params),
}))

export const createOrderInvoice = createAction('balance/invoice', (data) => ({
  payload: BalanceService.createInvoice(data),
}))

export const payInvoice = createAction('balance/invoice-paid', (data) => ({
  payload: BalanceService.sendInvoicePaid(data),
}))

export const removeInvoice = createAction('balance/invoice-delete', (invoiceId) => ({
  payload: BalanceService.deleteInvoice(invoiceId),
}))

export const downloadInvoicePDFMgr = createAction('balance/download-pdf-mgr', (invoiceId) => ({
  payload: BalanceService.downloadInvoicePDFMgr(invoiceId),
}))

export const downloadInvoicePDFAccount = createAction('balance/download-pdf-acc', (invoiceId) => ({
  payload: BalanceService.downloadInvoicePDFClient(invoiceId),
}))

export const fetchCompaniesInfo = createAction('balance/get-companies', () => ({
  payload: BalanceService.getCompaniesInfo(),
}))

export const fetchInvoiceParams = createAction('balance/get-params', () => ({
  payload: BalanceService.getInvoicesParams(),
}))

export const addCompaniesInfo = createAction('balance/add-companies', (data) => ({
  payload: BalanceService.createCompaniesInfo(data),
}))

export const changeCompaniesInfo = createAction('balance/edit-companies', (data) => ({
  payload: BalanceService.editCompaniesInfo(data),
}))

export const addInvoiceToInfo = createAction('balance/add-invoice-to', (data) => ({
  payload: BalanceService.createInvoiceToInfo(data),
}))

export const changeInvoiceToInfo = createAction('balance/edit-invoice-to', (data, id) => ({
  payload: BalanceService.editInvoiceToInfo(data, id),
}))

export const uploadLogo = createAction('balance/upload-logo', (data) => ({
  payload: BalanceService.uploadCompanyLogo(data),
}))

export const getLogo = createAction('balance/get-logo-comp', (companyId) => ({
  payload: BalanceService.getCompanyLogo(companyId),
}))


const initState = {
  list: getDefaultState(),
  list_account: getDefaultState(),
  list_invoices: getDefaultState(),
  list_replenishments: getDefaultState(),
  top_up: getDefaultState(),
  list_orders: getDefaultState(),
  generatePDF: getDefaultState(),
  generateCSV: getDefaultState(),
  changeBalance: getDefaultState(),
  invoice: getDefaultState(),
  invoicePaid: getDefaultState(),
  invoiceDelete: getDefaultState(),
  invoiceDownloadMgr: getDefaultState(),
  invoiceDownloadAcc: getDefaultState(),
  getCompanies: getDefaultState(),
  addCompanies: getDefaultState(),
  editCompanies: getDefaultState(),
  getParams: getDefaultState(),
  addInvoiceTo: getDefaultState(),
  editInvoiceTo: getDefaultState(),
  uploadLogo: getDefaultState(),
  getLogoComp: getDefaultState()
};

export default createReducer(initState, {
  ...getDefaultHandler(balanceFetchList, 'list'),
  ...getDefaultHandler(balanceFetchListNonMgr, 'list_account'),
  ...getDefaultHandler(balanceFetchListInvoices, 'list_invoices'),
  ...getDefaultHandler(balanceFetchListReplenishments, 'list_replenishments'),
  ...getDefaultHandler(balanceTopUp, 'top_up'),
  ...getDefaultHandler(balanceFetchListOrders, 'list_orders'),
  ...getDefaultHandler(balanceGeneratePDF, 'generatePDF'),
  ...getDefaultHandler(balanceGenerateCSV, 'generateCSV'),
  ...getDefaultHandler(customersChangeBalance, 'changeBalance'),
  ...getDefaultHandler(createOrderInvoice, 'invoice'),
  ...getDefaultHandler(payInvoice, 'invoicePaid'),
  ...getDefaultHandler(removeInvoice, 'invoiceDelete'),
  ...getDefaultHandler(downloadInvoicePDFMgr, 'invoiceDownloadMgr'),
  ...getDefaultHandler(downloadInvoicePDFAccount, 'invoiceDownloadAcc'),
  ...getDefaultHandler(fetchCompaniesInfo, 'getCompanies'),
  ...getDefaultHandler(addCompaniesInfo, 'addCompanies'),
  ...getDefaultHandler(changeCompaniesInfo, 'editCompanies'),
  ...getDefaultHandler(fetchInvoiceParams, 'getParams'),
  ...getDefaultHandler(addInvoiceToInfo, 'addInvoiceTo'),
  ...getDefaultHandler(changeInvoiceToInfo, 'editInvoiceTo'),
  ...getDefaultHandler(uploadLogo, 'uploadLogo'),
  ...getDefaultHandler(getLogo, 'getLogoComp')
})
